import { executeFetch } from 'api';
import type { AppNavigation } from 'app/sidebar/types';

export const fetchAppNavigation: AppNavigation = args =>
  executeFetch('categories/structure', args);
